import React from 'react'

import { Input } from '../../../components/Input'
import { Container } from './styles'

export interface TextInputProps
  extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  /**
   * ID attribute
   */
  id?: string

  /**
   * Class name
   */
  className?: string

  /**
   * Name attribute
   */
  name?: string

  /**
   * Placeholder attribute
   */
  placeholder?: string

  /**
   * Value attribute
   */
  value?: string

  /**
   * Disabled state
   */
  disabled?: boolean

  /**
   * hasError state
   */
  hasError?: boolean

  /**
   * Is isMultipleLine state
   */
  isMultipleLine?: boolean

  /**
   * Auto-adjust height on multi-line text input
   */
  autoHeight?: boolean
}

export const TextInputInner = (
  {
    type = 'text',
    isMultipleLine,
    autoHeight = false,
    value,
    hasError = false,
    ...rest
  }: TextInputProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  return (
    <Container isMultipleLine={isMultipleLine} hasError={hasError}>
      {!isMultipleLine && (
        <Input
          variant="input"
          ref={ref as React.Ref<HTMLInputElement>}
          type={type}
          value={value}
          error={hasError}
          {...rest}
        />
      )}
      {isMultipleLine && (
        <Input
          variant="textarea"
          ref={ref as React.Ref<HTMLTextAreaElement>}
          error={hasError}
          value={value}
          autoHeight={autoHeight}
          {...rest}
        />
      )}
    </Container>
  )
}

export const TextInput = React.forwardRef(TextInputInner) as (
  props: TextInputProps & { ref?: React.ForwardedRef<HTMLInputElement> },
) => ReturnType<typeof TextInputInner>
